import Theme from './theme/config'
import Login from './pages/Login'
import ChangePassword from './pages/ChangePassword'
import Index from './pages/Index'
import DataProvider from './context/dataContext'
import {HashRouter as Router, Switch, Route} from 'react-router-dom';
import PrivateRoute from './components/privateRoute'

function App() {
  return (
    <DataProvider>
      <Theme>
        <Router>
            <Switch>
              <Route exact path="/login" component={Login} />
              <PrivateRoute exact path="/changePassword" component={ChangePassword} />
              <PrivateRoute exact path='/' component={Index} />
            </Switch>
          </Router>
      </Theme>
    </DataProvider>
  );
}

export default App;